<template>
  <section class="qrs-typography">
    <pageHeader class="mb--0">
      <h2 class="qrs-header-xl mt--0 mb--0">My wellbeing diary - Entries</h2>
    </pageHeader>
    <div>
      <a
        @click="goBack"
        class="govuk-back-link"
        role="button"
        aria-label="go back to the previous screen"
      >
        <strong>Previous</strong>
      </a>

      <button
        type="button"
        name="Share"
        aria-label="Share questions and answers"
        class="govuk-button mt--16 mb--24"
        @click="$parent.goTo($Share)"
      >
        Share
        <span class="screen-reader-text">Share questions and answers</span>
      </button>

      <hr class="mb--24 divider" />
      <div class="align-text--center">
        <!-- <a
          class="govuk-button govuk-button--neutral"
          href="https://rightdecisions.scot.nhs.uk/living-well-with-dementia-for-everyone/for-everyone-help-and-support/"
          target="_blank"
          >Would you like support?</a
        > -->
        <button
          type="button"
          name="Share"
          aria-label="Share questions and answers"
          class="govuk-button govuk-button--neutral mt--16 mb--24"
          @click="$parent.goTo($helpAndSupport)"
          >Would you like support?</button
        >
      </div>
    </div>

    <!-- <p>store: {{this.$parent.statementAnswers}}</p> -->

    <div v-for="(item, index) in $parent.statementAnswers" v-bind:key="index">
      <div
        v-for="(innerItem, innerIndex) in item.data"
        v-on:click="goToStatement(innerIndex, innerItem)"
        v-bind:key="innerIndex"
      >
        <div
          class="item__panel"
          v-if="mostRecent(innerItem.answers).length > 0"
        >
          <div
            v-for="(latestAnswer, index) in mostRecent(innerItem.answers)"
            v-bind:key="index"
          >
            <div class="govuk-grid-row">
              <div class="govuk-grid-column-full">
                <div class="item__panel__header">
                  <h4 class="m-0">{{ innerItem.title }}</h4>
                  <p class="m-0">
                    {{ displaydate(formatDateAndTime(latestAnswer.date)) }}
                  </p>
                  <span class="hdr__label"> View graph </span>
                </div>
                <hr />
              </div>
            </div>

            <div class="govuk-grid-row">
              <div class="item__panel__content m-0">
                <div class="govuk-grid-column-one-half">
                  <div style="float: left">
                    <span class="label">Answer</span>
                    <p>{{ latestAnswer.answer }}</p>
                  </div>
                </div>
                <div class="govuk-grid-column-one-half">
                  <div style="float: right">
                    <div
                      v-if="latestAnswer.answer == 'Disagree'"
                      class="score__badge ml-0 score__badge--disagree-active"
                    >
                      <i class="fa fa-frown fa-frown--active"></i>
                    </div>
                    <div
                      v-else
                      class="score__badge score__badge--disagree ml-0"
                    >
                      <i class="fa fa-frown"></i>
                    </div>

                    <div
                      v-if="latestAnswer.answer == 'Neutral'"
                      class="score__badge ml-0 score__badge--neutral-active"
                    >
                      <i class="fa fa-meh fa-meh--active"></i>
                    </div>
                    <div v-else class="score__badge score__badge--neutral ml-0">
                      <i class="fa fa-meh"></i>
                    </div>

                    <div
                      v-if="latestAnswer.answer == 'Agree'"
                      class="score__badge ml-0 mr-0 score__badge--agree-active"
                    >
                      <i class="fa fa-smile fa-smile--active"></i>
                    </div>
                    <div
                      v-else
                      class="score__badge score__badge--smile ml-0 mr-0"
                    >
                      <i class="fa fa-smile"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import helpers from "./../../helpers/helper.js";

export default {
  name: "myWellbeingDiary",

  data() {
    return {
      scoreNames: this.$scoreNames,
      pickerDate: new Date().toISOString().substring(0, 10),
    };
  },

  methods: {
    handleClick(e) {
      if (e.target.matches("a")) {
        let url = e.target.href;
        let target = e.target.target == "_blank" ? "_blank" : "_self";
        let dataId = e.target.dataset.id == null ? -1 : e.target.dataset.id;
        var isnativeapp = document.getElementById("isnativeapp");
        if (isnativeapp === undefined || isnativeapp === null) {
          window.open(url, target);
        } else {
          if (url.includes("#")) {
            window.Native("dataCallback", url);
          }
          if (target == "_blank") {
            let data = { title: "", nodeid: dataId, href: url, target: target };
            window.Native("dataCallback", data);
          }
        }
      }
    },

    goBack() {
      this.$parent.goTo(this.$Intro);
    },

    mostRecent(items) {
      var result = [];
      var mostRecent = null;
      if (this.pickerDate === "") {
        this.pickerDate = new Date().toISOString().substring(0, 10);
      }
      var date = new Date(this.pickerDate);
      date.setHours(23, 59, 59, 999);

      for (var i = 0; i < items.length; i++) {
        if (items[i].date > date.toISOString()) {
          console.log(items);
          continue;
        }
        if (i == 0) {
          mostRecent = items[i];
        } else {
          if (mostRecent == null || items[i].date > mostRecent.date) {
            mostRecent = items[i];
          }
        }
      }

      if (mostRecent != null) {
        result.push(mostRecent);
      }
      return result;
    },

    formatDate(dateString) {
      var date = new Date(dateString);
      if (helpers.isToday(date)) {
        return helpers.getTime(dateString);
      }
      return helpers.formatDate(date) + ", " + helpers.getTime(dateString);
    },

    goToStatement(id, statement) {
      this.$parent.openStatement = statement;
      this.$parent.openStatementId = id;
      this.$parent.goTo(this.$StatementDetails);
    },

    ...helpers,
  },
};
</script>